import type { Path } from 'react-hook-form'
import type { FlightLogFormData } from '../form'
import type { FlightLogSectionContext } from '../useFlightLogForm'
import { NumRow } from '../../ui/prntr-fields'
import { PrntrGroup } from '../../ui/prntr-input'
import { SectionLabel } from '../../ui/prntr-input'

export function OilSection({ context }: { context: FlightLogSectionContext }) {
  const { control, values, readOnly } = context
  return (
    <>
      <SectionLabel>Oil uplift</SectionLabel>
      <PrntrGroup>
        {values.oil.engines.map((_, i) => (
          <NumRow
            key={`oil-up-${i}`}
            control={control}
            name={`oil.engines.${i}.upliftQts` as Path<FlightLogFormData>}
            label={`Engine ${i + 1}`}
            suffix="QTS"
            readOnly={readOnly}
          />
        ))}
        <NumRow
          control={control}
          name="oil.apuUpliftQts"
          label="APU Oil Uplift"
          suffix="QTS"
          readOnly={readOnly}
        />
        <NumRow
          control={control}
          name="oil.hydUpliftQts"
          label="HYD Oil Uplift"
          suffix="QTS"
          readOnly={readOnly}
        />
        <NumRow
          control={control}
          name="oil.psiDif"
          label="PSI DIF"
          suffix="PSID"
          readOnly={readOnly}
        />
      </PrntrGroup>
      <SectionLabel>Oil remaining - 10 min after shutdown</SectionLabel>
      <PrntrGroup>
        {values.oil.engines.map((_, i) => (
          <NumRow
            key={`oil-rem-${i}`}
            control={control}
            name={`oil.engines.${i}.remainingQts` as Path<FlightLogFormData>}
            label={`Engine ${i + 1}`}
            suffix="QTS"
            readOnly={readOnly}
          />
        ))}
      </PrntrGroup>
    </>
  )
}
